import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Button, Space, Typography } from 'antd';

import { Blotter } from 'reusable';
import {
  fetchAllAssets,
  fetchAssets,
  fetchCurrencies,
  retrieveAdminPlayer,
  selectors,
} from 'state';
import { LoadingScreen } from 'components';
import OrderModal from './OrderModal';
import OpenOrders from './OpenOrders';

const Player: React.FC = () => {
  const dispatch = useDispatch();
  const { player_id, session_id } = useParams<{
    player_id: string;
    session_id: string;
  }>();
  const playerId = Number(player_id);
  const sessionId = Number(session_id);

  const player = useSelector(selectors.playerById(playerId));
  const session = useSelector(selectors.sessionById(sessionId));

  const [visibleModal, setVisibleModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (player?.fetched_data) return;
    // dispatch(fetchAssets({}));
    dispatch(fetchAllAssets({}));
    dispatch(fetchCurrencies({}));
    dispatch(retrieveAdminPlayer({ player_id: playerId, session_id: sessionId }));
    setLoading(true);
  }, [loading, player?.fetched_data, dispatch, playerId, sessionId]);

  if (!player?.fetched_success || !session) {
    return <LoadingScreen />;
  }

  return (
    <Space direction="vertical" size={15} style={{ display: 'flex' }}>
      <Button type="primary" onClick={() => setVisibleModal(true)}>
        New Order
      </Button>

      <Typography.Title level={4} style={{ margin: 0 }}>
        Blotter
      </Typography.Title>
      <Blotter playerId={playerId} sessionId={sessionId} />

      <Typography.Title level={4} style={{ margin: 0 }}>
        Open orders
      </Typography.Title>
      <OpenOrders playerId={playerId} />

      <OrderModal
        visible={visibleModal}
        hide={() => setVisibleModal(false)}
        playerId={playerId}
        sessionId={sessionId}
      />
    </Space>
  );
};

export default Player;
